export function getProjectWebinar(project, fallbackUrl) {
  let webinar = project?.webinar;
  if (!webinar && fallbackUrl) {
    try {
      const url = new URL(fallbackUrl);
      const match = url.pathname.match(/^\/embed\/([A-Za-z0-9_-]{11})$/);
      if (url.protocol !== "https:" || !["www.youtube.com", "www.youtube-nocookie.com"].includes(url.hostname) || !match) return null;
      const start = url.searchParams.get("start") || "0";
      if (!/^\d+$/.test(start)) return null;
      webinar = { videoId: match[1], startSeconds: Number(start) };
    } catch {
      return null;
    }
  }
  if (!webinar || !/^[A-Za-z0-9_-]{11}$/.test(webinar.videoId)) return null;
  const start = webinar.startSeconds ?? 0;
  if (!Number.isSafeInteger(start) || start < 0) return null;
  const watch = new URL("https://www.youtube.com/watch");
  watch.searchParams.set("v", webinar.videoId);
  const embed = new URL(`https://www.youtube-nocookie.com/embed/${webinar.videoId}`);
  if (start > 0) {
    watch.searchParams.set("t", `${start}s`);
    embed.searchParams.set("start", String(start));
  }
  return {
    watchUrl: watch.href,
    embedUrl: embed.href,
    label: webinar.kind === "kickoff" ? "Community kickoff" : "Webinar",
    title: webinar.title || `${project?.name || "OpenScope"} presentation`
  };
}